import ReactDOM from 'react-dom';
import React from 'react';
import 'babel-polyfill';
import 'url-search-params-polyfill';

import Root from './views/common/components/Root';
import Routes from './core/routes';
import { store, history } from './core/store';
import registerServiceWorker from './registerServiceWorker';

const render = (reduxStore, browserHistory, routes) => {
  ReactDOM.render(
    <Root store={reduxStore} history={browserHistory} routes={routes} />,
    document.getElementById('root')
  );
};

render(store, history, Routes);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js